// extracted by mini-css-extract-plugin
module.exports = {"default":"PopularPosts--default--Xvc8I"};